import React,{useState,useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { submitContactUs } from "./../../actions/contactUsActions.js";
import './index.css';




function ContactUs(props) {
  
    const [name,setName]=useState(null);
    const [phone,setPhone]=useState(null);
    const [email,setEmail]=useState(null);
    const [message,setMessage]=useState(null);
    const finish = useSelector((state) => state.contactus.finish);
    const dispatch = useDispatch();

    function handleSubmit(e)
    {
        e.preventDefault();
        var data={
            name:name,
            phone:phone,
            email:email,
            message:message
        };
        dispatch(submitContactUs(data));
    }

    useEffect(()=>{
            if (finish==true)
            {
                window.location.reload();
            }
    },[finish]);

  return (
    <div className="row item">
        
    <div className="row main_row" >
       
         <div className="card card-content z-depth-3" >
               
        

               <form action="" method="post"  onSubmit={handleSubmit}>
                       
                       <div className="input-field">
                           <span>Your name</span>
                           <input type="text" name="name" placeholder="Fill your name"  onChange={(e)=>setName(e.target.value)} required />
                       </div>
                       <div className="input-field">
                           <span>Your phone</span>
                           <input type="text" name="phone" placeholder="Fill your phone number" onChange={(e)=>setPhone(e.target.value)} required />
                       </div>
                       <div className="input-field">
                           <span>Your email</span>
                           <input type="text" name="email" placeholder="Fill your email" onChange={(e)=>setEmail(e.target.value)} required />
                       </div>
                       <div className="input-field">
                           <span>Your Message</span>
                           <textarea name="message" className="materialize-textarea" onChange={(e)=>setMessage(e.target.value)} required></textarea>
                       </div>
                       <div className="input-field center">
                            <input type="submit"  style={{backgroundColor:'#'+props.custom_design.colors[0].color,color:"black"}}  class="btn  btn-large darken-2" value="Send" />
                       </div>
               </form>
           </div>
       </div>
       

    </div>



  
    );
}
export default ContactUs;
